<template>
  <div>
    <!-- Filter Start -->
    <highlight-filter
      :getFilterOnStart="true"
      :is_customer_page="false"
      @filterChange="changeFilter"
    ></highlight-filter>
    <!-- Filter End -->

    <!-- Stats Start -->
    <div class="row">
      <div class="col-md-6 mt-4">
        <div class="innerBox">
          <!-- <div class="row"> -->

          <!-- col-8 -->
          <highlight-oil-maker-stats
            id="1"
            title="QR Orders"
            description="jumlah botol berlabel qr yang dikirimkan oleh label maker ke botol maker"
            :value="
              data.stats
                ? data.stats.total_order != null
                  ? numberWithCommas(data.stats.total_order)
                  : 0
                : 'Loading...'
            "
          ></highlight-oil-maker-stats>
          <!-- <div class="col-4 stats--icon">
                            <i class="far fa-qrcode fa-5x"></i>
                        </div> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="col-md-6 mt-4">
        <div class="innerBox">
          <!-- <div class="row"> -->

          <!-- col-8 -->
          <highlight-oil-maker-stats
            id="2"
            title="Scan Activity"
            description="jumlah scan oleh oil maker pada konveyor mesin pengisian oli"
            :value="
              data.stats
                ? data.stats.total_scan != null
                  ? numberWithCommas(data.stats.total_scan)
                  : 0
                : 'Loading...'
            "
          ></highlight-oil-maker-stats>

          <!-- <div class="col-4 stats--icon">
                            <i class="far fa-barcode-read fa-4x"></i>
                        </div> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="col-md-6 mt-4">
        <div class="innerBox">
          <!-- <div class="row"> -->

          <!-- col-8 -->
          <highlight-oil-maker-stats
            id="3"
            title="QR Active"
            description="jumlah botol oli (QR Code) yang aktif oleh oil maker"
            :value="
              data.stats
                ? data.stats.active != null
                  ? numberWithCommas(data.stats.active)
                  : 0
                : 'Loading...'
            "
          ></highlight-oil-maker-stats>

          <!-- <div class="col-4 stats--icon">
                            <i class="fas fa-check fa-4x"></i>
                        </div> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="col-md-6 mt-4">
        <div class="innerBox">
          <!-- <div class="row"> -->

          <!-- col-8 -->
          <highlight-oil-maker-stats
            id="4"
            title="QR Deactive"
            description="jumlah botol oli (QR code) yang dinonaktifkan oleh oil maker"
            :value="
              data.stats
                ? data.stats.deactivate != null
                  ? numberWithCommas(data.stats.deactivate)
                  : 0
                : 'Loading...'
            "
          ></highlight-oil-maker-stats>

          <!-- <div class="col-4 stats--icon">
                            <i class="far fa-times fa-5x"></i>
                        </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <!-- Stats End -->

    <!-- Vertical Chart Start -->
    <!-- <div class="col-md-13">
      <div class="innerBox chart">
        <h5 class="elegant--sub-title">
          QR vs Active
          <i class="far fa-info-circle" :id="'scanDeactivateInfo'"></i>
          <b-popover target="scanDeactivateInfo" triggers="hover" placement="top">
            <template #title>QR vs Scan</template>
            {{ tooltip.qr_vs_active }}
          </b-popover>
        </h5>
        <oil-maker-q-r-scan-distribution v-if="data.oilBarScan" :data="data.oilBarScan" :filter="filter"></oil-maker-q-r-scan-distribution>
        <div v-else class="text-center mt-5 mb-5">
          <h2 class="pt-5 pb-5">Loading...</h2>
        </div>
      </div>
    </div> -->
    <!-- Vertical Chart End -->

    <!-- Pie Chart Start -->
    <!-- <div class="col-md-13">
      <div class="innerBox chart">
        <h5 class="elegant--sub-title">
          QR Active by Oil Maker
          <i class="far fa-info-circle" :id="'oilMarkerInfo'"></i>
          <b-popover target="oilMarkerInfo" triggers="hover" placement="top">
            <template #title>QR Active by Oil Maker</template>
            {{ tooltip.qr_active_by_oil_maker }}
          </b-popover>
        </h5>
        <h5 class="elegant--sub-title"></h5>
        <oil-maker-q-r-scan-detailed v-if="data.qrScanByOilMaker" :data="data.qrScanByOilMaker"></oil-maker-q-r-scan-detailed>
        <div v-else class="text-center mt-5 mb-5">
          <h2 class="pt-5 pb-5">Loading...</h2>
        </div>
      </div>
    </div> -->
    <!-- Pie Chart End -->

    <div class="row">
      <div class="col-12 mt-4">
        <div class="innerBox chart h-100">
          <h5 class="elegant--sub-title">
            QR Orders By Variant
            <!-- <i
                            class="far fa-info-circle"
                            :id="'LabelMakerInfo'"
                        ></i>
                        <b-popover target="LabelMakerInfo" triggers="hover" placement="top">
                          <template #title>QR Active By Label Maker</template>
                            {{tooltip.qr_active_by_label_maker}}
                        </b-popover> -->
          </h5>
          <q-r-orders-oil-maker-by-variant
            v-if="data.QROrdersOilMakerByVariant"
            :chartData="data.QROrdersOilMakerByVariant"
            :filter="filter"
          ></q-r-orders-oil-maker-by-variant>
          <div v-else class="text-center mt-5 mb-5">
            <h2 class="pt-5 pb-5">Loading...</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mt-4">
        <div class="innerBox chart h-100">
          <h5 class="elegant--sub-title">
            QR Orders By Label Maker
            <!-- <i
                            class="far fa-info-circle"
                            :id="'LabelMakerInfo'"
                        ></i>
                        <b-popover target="LabelMakerInfo" triggers="hover" placement="top">
                          <template #title>QR Active By Label Maker</template>
                            {{tooltip.qr_active_by_label_maker}}
                        </b-popover> -->
          </h5>
          <div class="chart-container">
            <q-r-orders-oil-maker-by-label-maker
              v-if="data.QROrdersOilMakerByLabelMaker"
              :chartData="data.QROrdersOilMakerByLabelMaker"
              :filter="filter"
            ></q-r-orders-oil-maker-by-label-maker>
            <div v-else class="text-center mt-5 mb-5">
              <h2 class="pt-5 pb-5">Loading...</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-4">
        <div class="innerBox chart h-100">
          <h5 class="elegant--sub-title">
            QR Orders By Bottle Maker
            <!-- <i
                            class="far fa-info-circle"
                            :id="'LabelMakerInfo'"
                        ></i>
                        <b-popover target="LabelMakerInfo" triggers="hover" placement="top">
                          <template #title>QR Active By Label Maker</template>
                            {{tooltip.qr_active_by_label_maker}}
                        </b-popover> -->
          </h5>
          <div class="chart-container">
            <q-r-orders-oil-maker-by-bottle-maker
              v-if="data.QROrdersOilMakerByBottleMaker"
              :chartData="data.QROrdersOilMakerByBottleMaker"
              :filter="filter"
            ></q-r-orders-oil-maker-by-bottle-maker>
            <div v-else class="text-center mt-5 mb-5">
              <h2 class="pt-5 pb-5">Loading...</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-4">
        <div class="innerBox chart h-100">
          <h5 class="elegant--sub-title">
            QR Orders By Oil Maker
            <!-- <i
                            class="far fa-info-circle"
                            :id="'LabelMakerInfo'"
                        ></i>
                        <b-popover target="LabelMakerInfo" triggers="hover" placement="top">
                          <template #title>QR Active By Label Maker</template>
                            {{tooltip.qr_active_by_label_maker}}
                        </b-popover> -->
          </h5>
          <q-r-orders-oil-maker-by-oil-maker
            v-if="data.QROrdersOilMakerByOilMaker"
            :chartData="data.QROrdersOilMakerByOilMaker"
            :filter="filter"
          ></q-r-orders-oil-maker-by-oil-maker>
          <div v-else class="text-center mt-5 mb-5">
            <h2 class="pt-5 pb-5">Loading...</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import highlightFilter from "@/components/filter/highlightFilter";

import highlightOilMakerStats from "./children/HighlightOilMakerStats";
import oilMakerQRScanDistribution from "./children/OilMakerQRScanDistribution";
import oilMakerQRScanDetailed from "./children/OilMakerQRScanDetailed";

import QROrdersOilMakerByVariant from "./children/QROrdersOilMakerByVariant.vue";
import QROrdersOilMakerByOilMaker from "./children/QROrdersOilMakerByOilMaker.vue";
import QROrdersOilMakerByLabelMaker from "./children/QROrdersOilMakerByLabelMaker.vue";
import QROrdersOilMakerByBottleMaker from "./children/QROrdersOilMakerByBottleMaker.vue";

export default {
  metaInfo: {
    title: "Highlight - Oil Maker",
  },
  data() {
    return {
      filter: {},
      data: {
        stats: null,
        oilBarScan: null,
        qrScanByOilMaker: null,
        QROrdersOilMakerByVariant: null,
        QROrdersOilMakerByBottleMaker: null,
        QROrdersOilMakerByLabelMaker: null,
        QROrdersOilMakerByOilMaker: null,
      },
      tooltip: this.$store.state.tooltip.highlight.oil_maker,
    };
  },
  components: {
    highlightFilter,

    highlightOilMakerStats,
    oilMakerQRScanDistribution,
    oilMakerQRScanDetailed,

    QROrdersOilMakerByVariant,
    QROrdersOilMakerByBottleMaker,
    QROrdersOilMakerByLabelMaker,
    QROrdersOilMakerByOilMaker,
  },
  // mounted() {
  //   this.fetchData();
  // },
  watch: {
    filter: {
      deep: true,
      handler: "fetchData",
    },
  },
  methods: {
    changeFilter(filter) {
      // for (var i in filter) this.filter[i] = filter[i];

      // this.fetchData();

      let newFilter = {};

      for (var i in filter) newFilter[i] = filter[i];

      this.filter = structuredClone(newFilter);
      this.vue_universal_table.filter = structuredClone(newFilter);

      //Delete unnecessary filter for the table
      delete this.vue_universal_table.filter.filter;
      // console.log('%cHighlightLabelMaker.vue line:262 filter', 'color: #007acc;', filter);
      // this.fetchData();
      this.vue_universal_table.update++;
    },
    fetchData() {
      //Reset All Data to null
      for (var i in this.data) this.data[i] = null;

      //Remove filter from filter
      let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
      delete filterlessFilter.filter;

      //Get Stats
      this.$http
        .get(
          `/api/highlight/oilmaker-scan-overview?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.stats = resp.data.data;
          console.log("oilmaker scan overview:", resp);
        })
        .catch((err) => {
          console.log(err);
        });

      //Get QR vs Scan
      // this.$http
      //   .get(`/api/highlight/oilmaker-variant-overview?${qs.stringify(this.filter, { skipNulls: true, arrayFormat: "comma" })}`)
      //   .then((resp) => {
      //     this.data.oilBarScan = resp.data.data;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

      //Get QR Scan by Oil Maker
      // this.$http
      //   .get(`/api/highlight/oilmaker-company-overview?${qs.stringify(filterlessFilter, { skipNulls: true, arrayFormat: "comma" })}`)
      //   .then((resp) => {
      //     this.data.qrScanByOilMaker = resp.data.data;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

      // Get QR Orders Oil Maker by Variant
      this.$http
        .get(
          `/api/highlight/oilmaker-qrorder-by-variant?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.QROrdersOilMakerByVariant = resp.data.data;
        })
        .catch((err) => {
          console.error("Error fetching QR Orders Oil Maker by Variant:", err);
        });

      // Get QR Orders Oil Maker by Label Maker
      this.$http
        .get(
          `/api/highlight/oilmaker-qrorder-by-labelmaker?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.QROrdersOilMakerByLabelMaker = resp.data.data;
        })
        .catch((err) => {
          console.error("Error fetching QR Orders Oil Maker by Label Maker:", err);
        });

      // Get QR Orders Oil Maker by Bottle Maker
      this.$http
        .get(
          `/api/highlight/oilmaker-qrorder-by-bottlemaker?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.QROrdersOilMakerByBottleMaker = resp.data.data;
        })
        .catch((err) => {
          console.error("Error fetching QR Orders Oil Maker by Bottle Maker:", err);
        });

      // Get QR Orders Oil Maker by Oil Maker
      this.$http
        .get(
          `/api/highlight/oilmaker-qrorder-by-oilmaker?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.QROrdersOilMakerByOilMaker = resp.data.data;
        })
        .catch((err) => {
          console.error("Error fetching QR Orders Oil Maker by Oil Maker:", err);
        });
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  height: 100%;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.chart h5 {
  height: 10%;
  margin-bottom: 0;
}

.chart-container {
  height: 90%;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

/* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
